import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { NoEncontradaComponent } from './components/no-encontrada/no-encontrada.component';
import { IngresoComponent } from './components/ingreso/ingreso.component';
import { ConsultaComponent } from './components/consulta/consulta.component';
import { DetalleComponent } from './components/detalle/detalle.component';

const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'ingreso', component: IngresoComponent},
  {path: 'consulta', component: ConsultaComponent},
  {path: 'detalle/:id', component: DetalleComponent},
  {path: 'no-encontrada', component: NoEncontradaComponent},
  {path: '**', redirectTo: 'no-encontrada'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
